export default "__VITE_ASSET__dpiJ5E22__"